import React from 'react';
import { Button, Icon } from './';

export function IconButton(props) {
  const {
    icon,
    bgcolor,
    iconColor,
    color,
    iconOnly,
    click,
    rounded,
    className,
    ...btnProps
  } = props;

  const handleClick = (event) => {
    if (click) {
      click(event);
    }
  };
  const buttonClassnames = ['chronos-icon-button'];
  if (className && className.length > 0) {
    buttonClassnames.push(className);
  }
  const radius = rounded ? '50%' : '4px';
  return (
    <Button
      icon
      color={color}
      iconOnly={iconOnly}
      style={{
        backgroundColor: bgcolor,

        borderRadius: radius,
      }}
      onClick={handleClick}
      className={buttonClassnames.join(' ')}
      {...btnProps}
    >
      <Icon icon={icon} style={{ color: iconColor || 'white' }} />
    </Button>
  );
}
